import { useSyncExternalStore } from 'react';
import { storage } from './storage';

/**
 * The client a super admin is acting as (null = all clients, read-only).
 * Sent to the API as `X-Act-As-Client`; ignored for everyone else.
 */
const KEY = 'fs.actAs';
let current: string | null = storage.get(KEY);
const listeners = new Set<() => void>();

export const actAs = {
  get: () => current,
  set(clientId: string | null) {
    current = clientId;
    storage.set(KEY, clientId);
    listeners.forEach((l) => l());
  },
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useActAs(): string | null {
  return useSyncExternalStore(actAs.subscribe, actAs.get, actAs.get);
}
